import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type JoinProgramRouteParams = {
  id: string;
};

export const joinProgram = async ({ routeParams: { id } }: RouteParamsRequest<JoinProgramRouteParams>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.program.join(id));
